import styled from "styled-components";
import { Input } from "antd";
import { BorderRadius, PRIMARY_THEME } from "../../constants/constant";

export const StyledSearchBar = styled(Input)`
  width: 335px;
  background: #ffffff;
  border-radius: ${BorderRadius};

  &:focus-within {
    border-color: ${PRIMARY_THEME};
  }
  &:hover {
    border-color: ${PRIMARY_THEME};
  }
`;
